import type { BoundaryCandidate, PlanOverlay } from './locate';

interface Overlay { frame?: number[]; corners?: [number, number][] }

interface PlanSource {
  documentId?: string | null;
  page?: number | null;
  overlay?: Overlay | null;
}

/** The parts of a plan-matching response needed to build its other candidate outlines. */
export interface CandidateSource extends PlanSource {
  documentName?: string | null;
  scaleDenominator?: number | null;
  candidates?: {
    boundary?: { ring?: [number, number][]; parts?: [number, number][][]; areaHa?: number } | null;
    overlay?: Overlay | null;
    source?: string | null;
    score?: number | null;
  }[] | null;
}

export function planFrom(r: PlanSource): PlanOverlay | undefined {
  const { documentId, page, overlay } = r;
  if (!documentId || !page || !overlay || overlay.frame?.length !== 4 || overlay.corners?.length !== 4) return undefined;
  const [x0, y0, x1, y1] = overlay.frame;
  return { documentId, page, frame: [x0, y0, x1, y1], corners: overlay.corners };
}

export function candidatesFrom(r: CandidateSource, areaHa: number): BoundaryCandidate[] {
  const out: BoundaryCandidate[] = [];
  for (const c of r.candidates ?? []) {
    const ring = c.boundary?.ring;
    if (!Array.isArray(ring) || ring.length < 4) continue;
    const plan = planFrom({ documentId: r.documentId, page: r.page, overlay: c.overlay });
    out.push({
      source: c.source === 'parcels' ? 'parcels' : 'map',
      boundary: {
        ring,
        ...(c.boundary?.parts?.length ? { parts: c.boundary.parts } : {}),
        areaHa: c.boundary?.areaHa ?? areaHa,
        placement: 'matched',
        confidence: 'Low',
        documentName: r.documentName ?? undefined,
        scaleDenominator: r.scaleDenominator ?? undefined,
        evidence: [],
        warnings: [],
        userEdited: false,
        ...(plan ? { plan } : {}),
      },
    });
  }
  return out;
}
